/* PALASIG – interattività pagina prodotto */
(function () {
  'use strict';
  const $ = (s, r) => (r || document).querySelector(s);
  const $$ = (s, r) => Array.from((r || document).querySelectorAll(s));

  /* ---------- menu mobile ---------- */
  const burger = $('#burger'), mobileNav = $('#mobileNav');
  if (burger) burger.addEventListener('click', () => mobileNav.classList.toggle('open'));

  /* ---------- galleria ---------- */
  const track = $('#galTrack');
  if (track) {
    const slides = $$('img', track);
    const thumbs = $('#galThumbs');
    let idx = 0;

    slides.forEach((img, i) => {
      const t = document.createElement('img');
      t.src = img.src;
      t.alt = '';
      t.addEventListener('click', () => go(i));
      thumbs.appendChild(t);
    });

    function go(i) {
      idx = (i + slides.length) % slides.length;
      track.style.transform = `translateX(-${idx * 100}%)`;
      $$('img', thumbs).forEach((t, k) => t.classList.toggle('active', k === idx));
      const active = $$('img', thumbs)[idx];
      if (active) active.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
    }
    $('.gal-arrow.prev').addEventListener('click', () => go(idx - 1));
    $('.gal-arrow.next').addEventListener('click', () => go(idx + 1));

    // swipe su mobile
    let x0 = null;
    track.addEventListener('touchstart', e => { x0 = e.touches[0].clientX; }, { passive: true });
    track.addEventListener('touchend', e => {
      if (x0 === null) return;
      const dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 45) go(idx + (dx < 0 ? 1 : -1));
      x0 = null;
    });
    go(0);
  }

  /* ---------- countdown offerta ---------- */
  const cd = $('#countdown');
  if (cd) {
    let left = 29 * 60;
    setInterval(() => {
      left = left > 0 ? left - 1 : 29 * 60;
      const m = String(Math.floor(left / 60)).padStart(2, '0');
      const s = String(left % 60).padStart(2, '0');
      cd.textContent = `${m}:${s}`;
    }, 1000);
  }

  /* ---------- carosello video + modale ---------- */
  const vcTrack = $('#vcTrack');
  if (vcTrack) {
    const step = () => vcTrack.clientWidth * 0.8;
    $('.vc-arrow.left').addEventListener('click', () => vcTrack.scrollBy({ left: -step(), behavior: 'smooth' }));
    $('.vc-arrow.right').addEventListener('click', () => vcTrack.scrollBy({ left: step(), behavior: 'smooth' }));

    const modal = $('#videoModal'), mv = $('#vmVideo');
    $$('.video-card').forEach(card => {
      const src = $('video', card).getAttribute('src');
      const open = () => {
        mv.src = src;
        modal.classList.add('open');
        mv.currentTime = 0;
        mv.play();
      };
      $('.play-btn', card).addEventListener('click', open);
      $('video', card).addEventListener('click', open);
    });
    const close = () => { modal.classList.remove('open'); mv.pause(); mv.removeAttribute('src'); };
    $('#vmClose').addEventListener('click', close);
    modal.addEventListener('click', e => { if (e.target === modal) close(); });
    document.addEventListener('keydown', e => { if (e.key === 'Escape') close(); });
  }

  /* ---------- carosello ingredienti ---------- */
  const ing = $('#ingCarousel');
  if (ing) {
    $$('.flip', ing).forEach(btn =>
      btn.addEventListener('click', () => btn.closest('.ing-card').classList.toggle('flipped')));
    const step = () => ing.clientWidth * 0.8;
    $('.ing-arrow.left').addEventListener('click', () => ing.scrollBy({ left: -step(), behavior: 'smooth' }));
    $('.ing-arrow.right').addEventListener('click', () => ing.scrollBy({ left: step(), behavior: 'smooth' }));
    const prog = $('#ingProgress');
    const upd = () => {
      const max = ing.scrollWidth - ing.clientWidth;
      const vis = (ing.clientWidth / ing.scrollWidth) * 100;
      prog.style.width = Math.max(vis, 8) + '%';
      prog.style.marginLeft = (max > 0 ? (ing.scrollLeft / max) * (100 - Math.max(vis, 8)) : 0) + '%';
    };
    ing.addEventListener('scroll', upd);
    window.addEventListener('resize', upd);
    upd();
  }

  /* ---------- marquee: duplica per loop continuo ---------- */
  const mq = $('#marqueeTrack');
  if (mq) {
    const html = mq.innerHTML;
    mq.innerHTML = html + html + html + html + html + html;
  }

  /* ---------- statistiche animate ---------- */
  const stats = $$('.stat-item');
  if (stats.length) {
    const io = new IntersectionObserver(entries => {
      entries.forEach(en => {
        if (!en.isIntersecting || en.target.dataset.done) return;
        en.target.dataset.done = '1';
        const target = parseInt(en.target.dataset.value, 10);
        const num = $('.stat-number', en.target);
        $('.stat-fill', en.target).style.width = target + '%';
        let cur = 0;
        const t = setInterval(() => {
          if (cur >= target) return clearInterval(t);
          num.textContent = ++cur + '%';
        }, 15);
      });
    }, { threshold: 0.4 });
    stats.forEach(s => io.observe(s));
  }

  /* ---------- recensioni ---------- */
  const list = $('#reviewsList');
  if (list && window.PALASIG_REVIEWS) {
    const data = window.PALASIG_REVIEWS;
    let shown = 0;
    const PAGE = 8;

    function stars(n) {
      let out = '';
      for (let i = 1; i <= 5; i++) out += `<i class="${i <= n ? '' : 'off'}"></i>`;
      return out;
    }
    function render() {
      data.slice(shown, shown + PAGE).forEach(r => {
        const li = document.createElement('li');
        li.className = 'rv-card';
        li.innerHTML = `
          <div class="rv-head">
            <span class="rv-name">${r.name}</span>
            <span class="rv-date">${r.date}</span>
          </div>
          <div class="rv-stars">${stars(Math.round(r.rating))}</div>
          <span class="rv-verify">Acquisto Verificato</span>
          <p class="rv-title">${r.title}</p>
          <p class="rv-body">${r.body}</p>
          ${r.img ? `<img class="rv-photo" src="assets/img/${r.img}" alt="" loading="lazy">` : ''}
          <div class="rv-foot">
            <span class="rv-product">
              <img src="${window.PALASIG_ASSETS}packshot.jpg" alt="">
              PALASIG – Siero Coreano Effetto Lifting dalla Prima Applicazione
            </span>
            <span class="rv-helpful">Questa recensione ti è servita? <b>${r.up}</b> · 0</span>
          </div>`;
        list.appendChild(li);
      });
      shown = Math.min(shown + PAGE, data.length);
      if (shown >= data.length) $('#loadMore').style.display = 'none';
    }
    render();
    $('#loadMore').addEventListener('click', render);
  }


  /* ---------- mock selettore bundle (in Shopify lo gestisce Kaching) ---------- */
  const kbOptions = $$('.kb-option');
  kbOptions.forEach(opt => opt.addEventListener('click', () => {
    kbOptions.forEach(o => o.classList.toggle('selected', o === opt));
  }));

  /* ================= carrello: spedizione gratuita e aggiunte =================
     Questo blocco sta PRIMA del carrello vero e proprio, perche' la
     conversione in tema Shopify sostituisce solo la parte del carrello:
     cosi' queste funzioni restano identiche in locale e online. */

  /* prezzi in centesimi, come li restituisce /cart.js */
  function eur(c) { return '\u20ac' + (c / 100).toFixed(2).replace('.', ','); }

  /* soglia della spedizione gratuita */
  window.PALASIG_FREESHIP = window.PALASIG_FREESHIP || 5900;

  /* Le aggiunte proposte nel carrello. Nel tema Shopify questo elenco lo
     scrive Liquid con gli id delle varianti vere; qui sotto c'e' la
     versione per l'anteprima locale. */
  window.PALASIG_UPSELL = window.PALASIG_UPSELL || [
    {id:'u1', title:'Crema Collo Liftante & Rassodante',  price:1995, compare:3990, img:'assets/img/linea-crema-collo.jpg'},
    {id:'u2', title:'Fondotinta AutoAdattivo con SPF15',  price:1995, compare:3990, img:'assets/img/linea-fondotinta.jpg'},
    {id:'u3', title:'Siero Luminosita Immediata PDRN',    price:1995, compare:3990, img:'assets/img/linea-siero-pdrn.jpg'},
    {id:'u4', title:'Stick Protettivo SPF 50+ | 2 in 1',  price:995,  compare:1990, img:'assets/img/linea-stick-spf.jpg'},
    {id:'u5', title:'Setting Spray Fissante Idratante',   price:1495, compare:2990, img:'assets/img/linea-spray-fissante.jpg'},
    {id:'u6', title:'Pennello Fondotinta Professionale',  price:495,  compare:990,  img:'assets/img/linea-pennello.jpg'}
  ];

  /* La barra dice due cose diverse a seconda del totale: quanto manca alla
     soglia, oppure che e' stata superata. Il riempimento e' proporzionale. */
  function renderShip(cart) {
    var box = document.getElementById('shipBar');
    if (!box) return;
    var soglia = window.PALASIG_FREESHIP;
    var manca = soglia - cart.total_price;
    var perc = Math.max(0, Math.min(100, Math.round(cart.total_price / soglia * 100)));
    document.getElementById('shipMsg').innerHTML = manca > 0
      ? 'Ti mancano solo <b>' + eur(manca) + '</b> per la <b>SPEDIZIONE GRATUITA</b>'
      : 'Hai sbloccato la <b>SPEDIZIONE GRATUITA</b>';
    document.getElementById('shipFill').style.width = perc + '%';
    document.getElementById('shipGoal').textContent = eur(soglia);
    box.classList.toggle('done', manca <= 0);
  }

  /* Mostra solo cio' che non e' gia' nel carrello: riproporre una cosa
     appena aggiunta fa sembrare il carrello rotto. */
  function renderUpsell(cart) {
    var box = document.getElementById('cartUpsell'), lista = document.getElementById('upList');
    if (!box || !lista) return;
    var dentro = (cart.items || []).map(function (i) { return String(i.variant_id); });
    var liberi = (window.PALASIG_UPSELL || []).filter(function (p) {
      return dentro.indexOf(String(p.id)) === -1;
    });
    box.hidden = liberi.length === 0;
    lista.innerHTML = liberi.map(function (p) {
      return '<div class="up-item">' +
        '<img src="' + p.img + '" alt="" loading="lazy" width="120" height="120">' +
        '<div class="up-txt"><div class="up-name">' + p.title + '</div>' +
        '<div class="up-price"><b>' + eur(p.price) + '</b>' +
        (p.compare > p.price ? '<s>' + eur(p.compare) + '</s>' : '') +
        '</div></div>' +
        '<button class="up-add" type="button" data-id="' + p.id + '">+ Aggiungi</button>' +
        '</div>';
    }).join('');
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('.up-add');
    if (!b) return;
    b.disabled = true;
    if (typeof window.palasigAggiungi === 'function') {
      window.palasigAggiungi(b.dataset.id, b);      /* Shopify */
    } else {
      b.closest('.up-item').remove();               /* anteprima locale */
    }
  });

  /* ---------- carrello Shopify (AJAX) ---------- */
  const drawer = $('#cartDrawer'), overlay = $('#cartOverlay');

  function money(cents) {
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }
  function openCart() { drawer.classList.add('open'); overlay.classList.add('open'); }
  function closeCart() { drawer.classList.remove('open'); overlay.classList.remove('open'); }

  function renderCart(cart) {
    const body = $('#cartBody');
    $('#cartCount').textContent = cart.item_count;
    $('#cartTotal').textContent = money(cart.total_price) + ' EUR';

    /* Barra spedizione e aggiunte vanno aggiornate sempre, anche a carrello
       vuoto: se no restano ferme all'ultimo stato mostrato. */
    if (typeof renderShip === 'function') renderShip(cart);
    if (typeof renderUpsell === 'function') renderUpsell(cart);

    if (!cart.items.length) {
      body.innerHTML = '<p class="cart-empty">Il tuo carrello è vuoto</p>';
      return;
    }
    body.innerHTML = cart.items.map(function (it, i) {
      /* La riga si identifica con la sua POSIZIONE, non con l'id variante:
         due righe possono avere la stessa variante con sconti diversi, ed e'
         esattamente quello che succede con i bundle. */
      var linea = i + 1;
      var barrato = it.original_line_price > it.final_line_price
        ? '<s>' + money(it.original_line_price) + '</s>' : '';
      return '<div class="cart-item">' +
        '<img src="' + (it.image || '') + '" alt="">' +
        '<div class="ci-main">' +
          '<div class="ci-name">' + it.product_title + '</div>' +
          (it.variant_title && it.variant_title !== 'Default Title'
            ? '<div class="ci-var">' + it.variant_title + '</div>' : '') +
          '<div class="ci-price"><b>' + money(it.final_line_price) + '</b> ' + barrato + '</div>' +
          '<div class="ci-tools">' +
            '<div class="qty">' +
              '<button type="button" class="q-less" data-line="' + linea + '">&minus;</button>' +
              '<span>' + it.quantity + '</span>' +
              '<button type="button" class="q-more" data-line="' + linea + '">+</button>' +
            '</div>' +
            '<button type="button" class="q-del" data-line="' + linea + '">Rimuovi</button>' +
          '</div>' +
        '</div>' +
        '</div>';
    }).join('');
  }

  /* quantita' e rimozione: una sola chiamata a /cart/change.js */
  function cambiaLinea(linea, quantita) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: Number(linea), quantity: Math.max(0, quantita) })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('.q-less, .q-more, .q-del');
    if (!b) return;
    var riga = b.closest('.cart-item');
    var ora = parseInt(riga.querySelector('.qty span').textContent, 10) || 1;
    var nuova = b.classList.contains('q-del') ? 0
              : b.classList.contains('q-more') ? ora + 1 : ora - 1;
    b.disabled = true;
    cambiaLinea(b.dataset.line, nuova).catch(function () { b.disabled = false; });
  });

  function fetchCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(renderCart);
  }

  if (drawer) {
    const form = $('#palasig-product-form');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        const btn = $('#atc');
        if (btn) btn.disabled = true;
        fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
          .then(function () { return fetchCart(); })
          .then(openCart)
          .catch(function () { window.location = '/cart'; })
          .finally(function () { if (btn) btn.disabled = false; });
      });
    }
    const cartBtn = $('#cartBtn');
    if (cartBtn) cartBtn.addEventListener('click', function () { fetchCart().then(openCart); });
    $('#cartClose').addEventListener('click', closeCart);
    overlay.addEventListener('click', closeCart);
    $('#checkout').addEventListener('click', function () { window.location = '/checkout'; });
    fetchCart();
  }

  /* Aggiunta di un'offerta dal carrello: la usa il pulsante "+ Aggiungi"
     definito piu' sopra, che in anteprima locale si limita a togliere la riga. */
  window.palasigAggiungi = function (id, btn) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    })
      .then(fetchCart)
      .catch(function () { if (btn) btn.disabled = false; });
  };

  /* ---------- trust slider (solo mobile) ---------- */
  const tt = $('#trustTrack');
  if (tt) {
    const dots = $$('.trust-dots .dot');
    let i = 0;
    setInterval(() => {
      if (window.innerWidth > 900) return;
      i = (i + 1) % dots.length;
      tt.scrollTo({ left: tt.clientWidth * i, behavior: 'smooth' });
      dots.forEach((d, k) => d.classList.toggle('active', k === i));
    }, 3500);
  }
})();
